// Shared translations for the application
export const translations = {
  nl: {
    // Common
    save: 'Opslaan',
    cancel: 'Annuleren',
    loading: 'Bezig met laden...',
    login: 'Inloggen',
    logout: 'Uitloggen',
    
    // MainPage
    addLink: 'Link Toevoegen',
    showLinks: 'Toon Links',
    options: 'Opties',
    batchDelete: 'Selectie Verwijderen',
    batchEdit: 'Selectie Aanpassen',
    batchCopy: 'Selectie Kopieëren',
    selectProject: 'Selecteer project',
    manageProjects: 'Voeg toe / verwijder project',
    
    // OptionsPage
    title: 'Opties',
    back: 'Terug',
    resetToDefaults: 'Reset naar standaardwaarden',
    linkTemplate: 'Link Template',
    textNormalization: 'Tekstinvoer normalisatie (alleen tekstvelden)',
    lowercase: 'Onderkast letters',
    replaceSpaces: 'Spatie vervangen door _',
    alphanumericOnly: 'Alleen letters/cijfers en _',
    fieldEnabled: 'Veld ingeschakeld',
    displayName: 'Weergavenaam',
    fieldType: 'Veldtype',
    date: 'Datum',
    text: 'Tekst',
    dropdown: 'Dropdown',
    gridOrder: 'Grid volgorde',
    gridWidth: 'Grid breedte (relatief)',
    required: 'Verplicht veld',
    autosuggest: 'Autosuggest (alleen tekstvelden)',
    autosuggestNote: 'Zet veldtype op Tekst om autosuggest te gebruiken',
    dropdownOptions: 'Dropdown opties:',
    dropdownNotUsed: '(Opties worden bewaard maar niet gebruikt zolang veld op Tekst staat)',
    addOption: 'Optie toevoegen',
    optionDisplayName: 'Weergavenaam',
    optionId: 'Afkorting (ID)',
    actions: 'Acties',
    noOptions: 'Geen opties. Klik op "Optie toevoegen" om te beginnen.',
    configSaved: 'Configuratie opgeslagen',
    errorSaving: 'Fout bij opslaan configuratie',
    configReset: 'Configuratie gereset naar standaardwaarden',
    selectProjectFirst: 'Selecteer eerst een project',
    
    // DataGrid
    edit: 'Bewerken',
    clone: 'Kopiëren',
    delete: 'Verwijderen',
    showFilters: 'Toon Filters',
    hideResetFilters: 'Verberg en Reset Filters',
    
    // AI Entry Generator
    aiCampaignGenerator: 'AI Campagne Generator',
    aiInstructions: 'Instructies voor AI',
    aiInstructionsPlaceholder: 'Beschrijf welke campagne entries je wilt genereren. Bijvoorbeeld: "Maak 5 Facebook campagnes voor zomer promotie" of "Genereer 3 LinkedIn B2B leads campagnes"',
    aiGenerateEntries: 'Genereer Entries',
    aiGenerating: 'AI genereert campagne entries...',
    aiPreview: 'Preview van gegenereerde entries',
    aiValidationErrors: 'Validatie fouten',
    aiSuccess: 'Entries succesvol gegenereerd!',
    aiAddEntries: 'Voeg Entries Toe',
    aiTryAgain: 'Opnieuw proberen',
    aiNoFieldsEnabled: 'Geen velden ingeschakeld. Schakel eerst velden in bij Opties.',
    aiEntriesPreview: 'Gegenereerde entries',
    aiEntriesCount: 'entries',
    aiAppliedSuccess: 'AI entries succesvol toegevoegd',
    aiAppliedError: 'Fout bij toevoegen van AI entries'
  },
  en: {
    // Common
    save: 'Save',
    cancel: 'Cancel',
    loading: 'Loading...',
    login: 'Login',
    logout: 'Logout',
    
    // MainPage
    addLink: 'Add Link',
    showLinks: 'Show Links',
    options: 'Options',
    batchDelete: 'Batch Delete',
    batchEdit: 'Batch Edit',
    batchCopy: 'Batch Copy',
    selectProject: 'Select project',
    manageProjects: 'Add / remove project',
    
    // OptionsPage
    title: 'Options',
    back: 'Back',
    resetToDefaults: 'Reset to defaults',
    linkTemplate: 'Link Template',
    textNormalization: 'Text input normalization (text fields only)',
    lowercase: 'Lowercase letters',
    replaceSpaces: 'Replace spaces with _',
    alphanumericOnly: 'Only letters/numbers and _',
    fieldEnabled: 'Field enabled',
    displayName: 'Display name',
    fieldType: 'Field type',
    date: 'Date',
    text: 'Text',
    dropdown: 'Dropdown',
    gridOrder: 'Grid order',
    gridWidth: 'Grid width (relative)',
    required: 'Required field',
    autosuggest: 'Autosuggest (text fields only)',
    autosuggestNote: 'Set field type to Text to use autosuggest',
    dropdownOptions: 'Dropdown options:',
    dropdownNotUsed: '(Options are saved but not used while field is set to Text)',
    addOption: 'Add option',
    optionDisplayName: 'Display name',
    optionId: 'Abbreviation (ID)',
    actions: 'Actions',
    noOptions: 'No options. Click "Add option" to begin.',
    configSaved: 'Configuration saved',
    errorSaving: 'Error saving configuration',
    configReset: 'Configuration reset to defaults',
    selectProjectFirst: 'Select a project first',
    
    // DataGrid
    edit: 'Edit',
    clone: 'Clone',
    delete: 'Delete',
    showFilters: 'Show Filters',
    hideResetFilters: 'Hide and Reset Filters',
    
    // AI Entry Generator
    aiCampaignGenerator: 'AI Campaign Generator',
    aiInstructions: 'Instructions for AI',
    aiInstructionsPlaceholder: 'Describe which campaign entries you want to generate. For example: "Create 5 Facebook campaigns for summer promotion" or "Generate 3 LinkedIn B2B lead campaigns"',
    aiGenerateEntries: 'Generate Entries',
    aiGenerating: 'AI is generating campaign entries...',
    aiPreview: 'Preview of generated entries',
    aiValidationErrors: 'Validation errors',
    aiSuccess: 'Entries successfully generated!',
    aiAddEntries: 'Add Entries',
    aiTryAgain: 'Try again',
    aiNoFieldsEnabled: 'No fields enabled. Please enable fields in Options first.',
    aiEntriesPreview: 'Generated entries',
    aiEntriesCount: 'entries',
    aiAppliedSuccess: 'AI entries successfully added',
    aiAppliedError: 'Error adding AI entries'
  }
};

// Helper function to get translations for a specific language
export const getTranslations = (language = 'nl') => {
  return translations[language] || translations.nl;
};

